<script setup lang="ts">
    import AllFiltersItem from './AllFiltersItem.vue';
    import { EchoFilterCheckbox } from '@/js/services/api/filter/types';
    import { __, __untypedExpression } from '@/js/stores/expressions';
    import SvgIcon from '../SvgIcon.vue';
    // Hide BanIcon temporarily, since the disabled state from backend is not reliable
    // import { BanIcon } from '@lucide/vue';

    const props = defineProps<{
        checkboxes: EchoFilterCheckbox[];
        type: 'direction' | 'sentiment';
    }>();
</script>

<template>
    <AllFiltersItem>
        <template v-if="$slots.icon" #icon>
            <slot name="icon" />
        </template>
        <slot />

        <template #content>
            <ul class="pt-1 mb-5">
                <li v-for="checkbox in checkboxes" :key="String(checkbox.id)" class="px-2 py-0.5">
                    <label
                        class="flex items-center cursor-pointer custom-focus-within rounded-lg py-1 pr-4 relative"
                        :class="{
                            'font-medium bg-gray-lightest': checkbox.isSelected,
                            'hover:bg-gray-lightest': !checkbox.isSelected,
                            // 'opacity-50': checkbox.isDisabled && !checkbox.isSelected,
                            // Remove opacity-50 temporarily since the disabled state from backend is not reliable
                        }"
                    >
                        <input
                            v-model="checkbox.isSelected"
                            type="checkbox"
                            :value="checkbox.id"
                            class="absolute opacity-0 -left-full"
                            :class="{ 'Checkbox--checked': checkbox.isSelected }"
                        />
                        <span class="rounded-full mr-1.5 ml-1 p-0.5 relative">
                            <!-- Hide block icon temporarily, since the disabled state from backend is not reliable -->
                            <!-- <span class="absolute block bottom-0 right-0 bg-white rounded-full z-1">
                                <BanIcon v-if="checkbox.isDisabled" class="size-4" />
                            </span> -->

                            <SvgIcon
                                v-if="props.type === 'direction'"
                                :name="'sentimentdirection-' + checkbox.name.toLowerCase() + '.svg'"
                                size="size-8"
                                class="fill-transparent stroke-transparent"
                                :class="{
                                    'opacity-50': false && checkbox.isDisabled,
                                    // Remove opacity-50 temporarily since the disabled state from backend is not reliable
                                }"
                            />
                            <SvgIcon
                                v-else
                                :name="'sentiment-' + checkbox.name.toLowerCase() + '.svg'"
                                size="size-8"
                                class="fill-transparent stroke-transparent"
                                :class="{
                                    'opacity-50': false && checkbox.isDisabled,
                                    // Remove opacity-50 temporarily since the disabled state from backend is not reliable
                                }"
                            />
                        </span>
                        {{ __untypedExpression('sentiment-' + checkbox.name.toLowerCase()) }}
                    </label>
                </li>
            </ul>
        </template>
    </AllFiltersItem>
</template>
